export const pluralFormat = (value: number, unit: string, hideNumber?: boolean) => {
  const units = unit.split(' ').map(u => (value > 1 && isNaN(+unit[unit.length]) ? `${u}s` : u));
  return hideNumber ? ` ${units}` : [value, ...units].join(' ');
};
